import React, { useEffect } from 'react';
import { node, instanceOf } from 'prop-types'
import LeftNav from '../../components/crosstabBeta/LeftNav';
import * as urls from '../../actions/urlTypes';

const CrosstabBeta = (props) => {
  useEffect(() => {
    if (!props.children) {
      props.router.push(`${urls.APP_ROOT_URL}/essentials/crosstab`);
    }
  }, [])

  return (
    <div className="crosstab2--root">
      <LeftNav />
      {props.children}
    </div>
  )
}

CrosstabBeta.propTypes = {
  children: node,
  router: instanceOf(Object),
}

export default CrosstabBeta